import React, { memo } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { TestimonialBox } from '../components/TestimonialBox';
import { ProductSidebar } from '../components/ProductSidebar';
import { CTASection } from '../components/CTASection';
import { StickyBottomBar } from '../components/StickyBottomBar';
export function AdvertorialPage() {
  const testimonials = [{
    author: 'Jennifer K., 41',
    location: 'Denver, CO',
    quote: 'I had TWO seizures trying to quit cold turkey. The Glisera patch let me prepare my nervous system first. I quit three months ago. No seizures. No ER.'
  }, {
    author: 'Sarah M., 38',
    location: 'Portland, OR',
    quote: "Hour 36 was always when I'd break. The shaking would get so bad I'd give in. With the patch, hour 36 came and went. No shaking. I just made it through."
  }, {
    author: 'Michelle R., 45',
    location: 'Boston, MA',
    quote: 'My heart rate hit 168 BPM the last time I tried. I was terrified to try again. The preparation method changed everything. My heart stayed under 95 the entire time.'
  }, {
    author: 'Lisa W., 52',
    location: 'Seattle, WA',
    quote: "I spent $12,000 on medical detox. It worked, but I relapsed and couldn't afford to do it again. The patch cost me $89 and worked just as well."
  }];
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-134">
      <Header data-id="element-135" />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-136">
        <div className="flex flex-col lg:flex-row gap-12" data-id="element-137">
          {/* Main Content Column */}
          <article className="w-full lg:w-[65%]" data-id="element-138">
            <Hero data-id="element-139" />

            {/* IMAGE 1: Hospital/paramedic emergency scene */}
            <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-140">
              <img src="https://cdn.magicpatterns.com/uploads/a6eaY2JEZa637DufrGdJXm/ChatGPT_Image_24_Φεβ_2026,_10_43_42_μ.μ..png" alt="Paramedics attending to woman on kitchen floor while husband holds crying daughter in doorway" className="w-full h-auto" data-id="element-141" />
            </div>

            <div className="prose prose-lg max-w-none text-gray-800 font-serif leading-relaxed" data-id="element-142">
              <p className="text-xl mb-6 font-semibold text-gray-900" data-id="element-143">
                The first thing I remember is voices.
              </p>

              <p className="mb-6" data-id="element-144">Urgent. Professional. Close.</p>

              <p className="mb-6" data-id="element-145">
                "Ma'am, can you hear me? Can you tell me your name?"
              </p>

              <p className="mb-6" data-id="element-146">I open my eyes. I'm on my kitchen floor.</p>

              <p className="mb-6" data-id="element-147">
                There are two paramedics kneeling over me. One has a blood
                pressure cuff on my arm. The other is shining a light in my
                eyes.
              </p>

              <p className="mb-6" data-id="element-148">"What... what happened?"</p>

              <p className="mb-6" data-id="element-149">
                "Your husband called 911. He found you on the floor. Do you
                remember falling?"
              </p>

              <p className="mb-6" data-id="element-150">I don't remember anything.</p>

              <p className="mb-6" data-id="element-151">
                My husband is standing in the doorway. His face is white. He's
                holding our daughter. She's crying.
              </p>

              <p className="mb-6" data-id="element-152">
                "You were seizing," he says quietly. "I came downstairs and you
                were on the floor, shaking. I thought you were dying."
              </p>

              <p className="mb-6" data-id="element-153">Seizing.</p>

              <p className="mb-6" data-id="element-154">The word doesn't make sense.</p>

              <p className="mb-6" data-id="element-155">
                "Ma'am, have you consumed any alcohol in the last 48 hours?"
              </p>

              <p className="mb-6" data-id="element-156">
                "No. I'm trying to quit. It's been... I don't know. Two days?
                Maybe more."
              </p>

              <p className="mb-6" data-id="element-157">The paramedics look at each other.</p>

              <p className="mb-8" data-id="element-158">
                "We need to take you in. Alcohol withdrawal seizures are
                serious. You need to be monitored."
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-159">
                I Was Just Trying to Do the Right Thing
              </h2>

              <p className="mb-6" data-id="element-160">
                Three days earlier, I'd made a decision. I was going to quit
                drinking.
              </p>

              <p className="mb-6" data-id="element-161">
                Not "cut back." Not "take a break." Actually quit.
              </p>

              <p className="mb-6" data-id="element-162">
                I'd been drinking two to three glasses of wine every night for
                six years. It had gone from "I deserve this" to "I need this" so
                gradually I didn't notice until it was too late.
              </p>

              <p className="mb-6" data-id="element-163">
                The 3 AM wake-ups with my heart pounding. The morning brain fog.
                The promises I'd make and break by 7 PM.
              </p>

              <p className="mb-6" data-id="element-164">I was done.</p>

              <p className="mb-6" data-id="element-165">So I just... stopped. Cold turkey.</p>

              <p className="mb-6" data-id="element-166">
                I thought that's what you were supposed to do. Just decide and
                stop.
              </p>

              <p className="mb-6" data-id="element-167">
                Day 1 was uncomfortable. Restless. Anxious. But I made it
                through.
              </p>

              <p className="mb-6" data-id="element-168">
                Night 1, I didn't sleep at all. Just lay there staring at the
                ceiling, heart racing.
              </p>

              <p className="mb-6" data-id="element-169">
                Day 2, I was exhausted and irritable, but proud of myself. "I'm
                doing it."
              </p>

              <p className="mb-6" data-id="element-170">
                Night 2, around 2 AM, things started feeling wrong. My heart was
                pounding irregularly. I was sweating but freezing. My hands
                started trembling.
              </p>

              <p className="mb-6" data-id="element-171">
                I told myself it was just withdrawal. It would pass.
              </p>

              <p className="mb-6" data-id="element-172">
                Morning of Day 3, I went downstairs to make coffee.
              </p>

              <p className="mb-8" data-id="element-173">That's the last thing I remember.</p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-174">
                What the ER Doctor Told Me
              </h2>

              {/* IMAGE 2: ER doctor consultation */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-175">
                <img src="https://cdn.magicpatterns.com/uploads/gRuEtgFds5bGQd9QVGGjKR/ChatGPT_Image_24_Φεβ_2026,_10_44_46_μ.μ..png" alt="Doctor in white coat showing brain diagram to patient in hospital bed" className="w-full h-auto" data-id="element-176" />
              </div>

              <p className="mb-6" data-id="element-177">
                The ER doctor sat down next to my bed after running tests.
              </p>

              <p className="mb-6" data-id="element-178">
                "You had a tonic-clonic seizure. Do you know what caused it?"
              </p>

              <p className="mb-6" data-id="element-179">
                "The paramedics said... alcohol withdrawal?"
              </p>

              <p className="mb-6" data-id="element-180">
                "That's right. How long have you been drinking daily?"
              </p>

              <p className="mb-6" data-id="element-181">
                "Five years. Maybe six. Two glasses of wine every night.
                Sometimes three."
              </p>

              <p className="mb-6" data-id="element-182">She didn't look surprised.</p>

              <p className="mb-6" data-id="element-183">
                "When you drink alcohol regularly for years, your brain adapts.
                It reduces production of GABA—a neurotransmitter that keeps your
                nervous system calm—because alcohol is doing that job. At the
                same time, your brain increases glutamate production, which
                excites your nervous system."
              </p>

              <p className="mb-6" data-id="element-184">She drew a simple diagram.</p>

              <p className="mb-6" data-id="element-185">
                "When you suddenly stop drinking, your GABA is still suppressed.
                But glutamate spikes. Your brain becomes hyperexcitable. Too
                much electrical activity with no way to calm it down."
              </p>

              <p className="mb-6" data-id="element-186">
                She drew lightning bolts in the brain diagram.
              </p>

              <p className="mb-6" data-id="element-187">
                "That's what causes seizures during withdrawal. Your brain is
                firing too much, too fast, with no brakes. And it can happen
                without warning—usually between 12 and 48 hours after your last
                drink."
              </p>

              <p className="mb-6" data-id="element-188">I stared at the diagram.</p>

              <p className="mb-6" data-id="element-189">"I could have died?"</p>

              <p className="mb-6" data-id="element-190">
                "Yes. Seizures can be fatal. Especially if you're alone. You
                were very lucky your husband found you when he did."
              </p>

              <p className="mb-6" data-id="element-191">She paused.</p>

              <p className="mb-6" data-id="element-192">
                "The first 72 hours are what we call the 'danger zone.' That's
                when most complications occur. Seizures typically happen between
                12 and 48 hours. Cardiac events can happen anytime in that
                window."
              </p>

              <p className="mb-6" data-id="element-193">
                "But I wasn't even a heavy drinker," I said. "Just wine with
                dinner."
              </p>

              <p className="mb-6" data-id="element-194">
                "It doesn't matter. Your body adapted. And when you removed
                alcohol suddenly, your body couldn't regulate itself."
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-195">
                "You cannot try to quit cold turkey again. Based on the seizure
                you just had, you're at high risk for another one. Next time,
                you might not be as lucky."
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-196">
                The Trap I Was In
              </h2>

              {/* IMAGE 3: Woman at kitchen table defeated */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-197">
                <img src="https://cdn.magicpatterns.com/uploads/6B5H7EdUwfbuDC8ApWvdBa/ChatGPT_Image_24_Φεβ_2026,_10_44_45_μ.μ..png" alt="Woman sitting at kitchen table overwhelmed with head in hands, medical bills and prescription bottles visible" className="w-full h-auto" data-id="element-198" />
              </div>

              <p className="mb-6" data-id="element-199">Dr. Martinez explained my options.</p>

              <p className="mb-6" data-id="element-200">
                "Medical detox. We admit you for 5-7 days, give you medications
                to prevent seizures, and monitor you through withdrawal. It's
                the safest way."
              </p>

              <p className="mb-6" data-id="element-201">"How much does that cost?"</p>

              <p className="mb-6" data-id="element-202">
                She hesitated. "With insurance, probably $5,000 to $10,000 out
                of pocket. Without insurance... $15,000 to $30,000."
              </p>

              <p className="mb-6" data-id="element-203">
                I felt the walls closing in. I couldn't afford that. I couldn't
                take a week off work without explanation.
              </p>

              <p className="mb-6" data-id="element-204">"What if I can't do inpatient?"</p>

              <p className="mb-6" data-id="element-205">
                She was quiet for a moment. "Honestly? Based on the seizure you
                just had, I strongly recommend medical supervision. Withdrawal
                can be life-threatening."
              </p>

              <p className="mb-6" data-id="element-206">
                She wrote something on a prescription pad. Handed it to me.
              </p>

              <p className="mb-6" data-id="element-207">
                "This medication can help reduce seizure risk. But you need to
                understand—if you try to quit cold turkey again, you're at high
                risk for another seizure. And next time, your daughter might be
                the one who finds you."
              </p>

              <p className="mb-6" data-id="element-208">
                Those words hit like a punch to the chest. My daughter had
                watched me convulse on the kitchen floor. She'd been terrified.
              </p>

              <p className="mb-8" data-id="element-209">
                I left the hospital with a prescription and zero hope.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-210">
                The Phone Call That Changed Everything
              </h2>

              <p className="mb-6" data-id="element-211">
                Two weeks after the seizure, my husband's college roommate
                called. Mike. He's an ER physician in another state.
              </p>

              <p className="mb-6" data-id="element-212">My husband had told him what happened.</p>

              <p className="mb-6" data-id="element-213">"Can I talk to Rachel?" Mike asked.</p>

              <p className="mb-6" data-id="element-214">My husband put him on speaker.</p>

              <p className="mb-6" data-id="element-215">
                "Rachel, I'm so sorry about what you went through. I've treated
                hundreds of patients in withdrawal. It's terrifying, and it's
                not your fault."
              </p>

              <p className="mb-6" data-id="element-216">I started crying.</p>

              <p className="mb-6" data-id="element-217">
                "Mike, I don't know what to do. I can't afford detox. I can't
                try to quit alone again. But I can't keep drinking."
              </p>

              <p className="mb-8" data-id="element-218">
                "I know. That's why I'm calling. There's something I think could
                help you."
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-219">
                What He Told Me
              </h2>

              {/* IMAGE 4: Phone conversation scene */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-220">
                <img src="https://cdn.magicpatterns.com/uploads/1mNfUnZJxFUWkwbtHKaeen/ChatGPT_Image_24_Φεβ_2026,_10_44_43_μ.μ..png" alt="Woman on phone taking notes with husband supporting in background" className="w-full h-auto" data-id="element-221" />
              </div>

              <p className="mb-6" data-id="element-222">
                "When you drink regularly," Mike explained, "your brain stops
                producing GABA naturally. When you quit cold turkey, you're
                asking a GABA-depleted brain to suddenly regulate itself. It
                can't. That's why you had the seizure."
              </p>

              <p className="mb-6" data-id="element-223">
                "For years, the only option was medical detox—medications that
                artificially calm your nervous system while your brain slowly
                rebuilds GABA. But there's another approach now."
              </p>

              <p className="mb-6" data-id="element-224">He paused.</p>

              <p className="mb-6" data-id="element-225">
                "It's called biochemical preparation. Instead of quitting first
                and treating the crisis after, you prepare your nervous system
                before you quit."
              </p>

              <p className="mb-6" data-id="element-226">"How?"</p>

              <p className="mb-6" data-id="element-227">
                "There's a transdermal patch system that delivers GABA
                precursors and magnesium threonate—the only form that crosses
                the blood-brain barrier. You wear it for 7 days while still
                drinking."
              </p>

              <p className="mb-6" data-id="element-228">"While still drinking?"</p>

              <p className="mb-6" data-id="element-229">
                "Yes. That's the key. During those 7 days, your brain rebuilds
                its natural GABA production. So when you do stop drinking, your
                brain isn't in hyperexcitable crisis mode anymore."
              </p>

              <p className="mb-6" data-id="element-230">
                "The seizure you had? That happens when your brain has zero GABA
                and maximum glutamate. But if you prepare first, that imbalance
                doesn't happen. The seizure risk is minimized."
              </p>

              <p className="mb-6" data-id="element-231">My hands were shaking as I took notes.</p>

              <p className="mb-6" data-id="element-232">"What's it called?"</p>

              <p className="mb-6" data-id="element-233">
                "Glisera. The Glisera Anti-Alcohol Patch. I've had patients who
                failed cold turkey multiple times—some who had seizures like
                you—use this method and succeed. No seizures. No ER visits."
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-234">
                "Please, Rachel. Don't try to quit cold turkey again. Prepare
                your body first."
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-235">
                Why This Made Sense When Nothing Else Did
              </h2>

              <p className="mb-6" data-id="element-236">
                That night, I researched until 2 AM. And for the first time in
                weeks, I felt hope.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-237">
                The Preparation Method:
              </h3>

              <p className="mb-6" data-id="element-238">
                You don't wear the patch when you're quitting. You wear it for 7
                days BEFORE you quit, while you're still drinking.
              </p>

              <p className="mb-6" data-id="element-239">
                During those 7 days, GABA precursors absorb through your skin,
                your brain rebuilds its natural calming mechanisms, and your
                nervous system's excitability normalizes.
              </p>

              <p className="mb-8" data-id="element-240">
                So when you stop drinking on Day 8, your brain isn't in crisis
                mode.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-241">
                Why Transdermal?
              </h3>

              <p className="mb-8" data-id="element-242">
                Mike explained: "Alcohol damages your gut lining. Even if you're
                taking supplements by mouth, your body can't absorb them
                properly. But transdermal delivery bypasses your digestive
                system entirely."
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-243">
                The Science:
              </h3>

              <div className="bg-gray-50 p-6 rounded-lg mb-8" data-id="element-244">
                <p className="mb-4" data-id="element-245">The patch contains:</p>
                <ul className="space-y-3 list-disc pl-6" data-id="element-246">
                  <li data-id="element-247">
                    <strong data-id="element-248">GABA Precursors</strong> - Rebuilds natural calming
                    neurotransmitter
                  </li>
                  <li data-id="element-249">
                    <strong data-id="element-250">Magnesium Threonate</strong> - The only form that
                    crosses the blood-brain barrier to calm neural
                    hyperexcitability
                  </li>
                  <li data-id="element-251">
                    <strong data-id="element-252">B-Vitamin Complex</strong> - Replenishes vitamins
                    depleted by alcohol
                  </li>
                  <li data-id="element-253">Compounds that support nervous system regulation</li>
                </ul>
                <p className="mt-4" data-id="element-254">
                  All delivered continuously over 24 hours.
                </p>
              </div>

              {/* IMAGE 5: Scientific diagram */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-255">
                <img src="https://cdn.magicpatterns.com/uploads/qvicic4CmZ1vz23sDNqkYA/ChatGPT_Image_24_Φεβ_2026,_10_44_38_μ.μ..png" alt="Scientific graph showing GABA production rebuilding from depleted to normal levels over 7 days" className="w-full h-auto" data-id="element-256" />
              </div>

              <p className="mb-8 font-bold text-gray-900" data-id="element-257">
                I ordered it at 2:47 AM.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-258">
                The Seven Days of Preparation
              </h2>

              {/* IMAGE PLACEHOLDER: Patch close-up */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm bg-gray-100 p-8 text-center" data-id="element-259">
                <p className="text-sm text-gray-600 italic" data-id="element-260">
                  [IMAGE NEEDED: Close-up of discreet flesh-toned patch on
                  woman's upper arm. Patch is small, thin, barely visible.
                  Natural lighting. Arm in relaxed position. Show that it's
                  completely unnoticeable under normal circumstances.
                  Professional product photography style.]
                </p>
              </div>

              <p className="mb-6" data-id="element-261">
                It arrived two days later. I opened it in my bathroom.
              </p>

              <p className="mb-6" data-id="element-262">
                My husband stood in the doorway. "You're sure about this?"
              </p>

              <p className="mb-6" data-id="element-263">
                "Mike said it works. And I can't try cold turkey again."
              </p>

              <p className="mb-6" data-id="element-264">
                <strong data-id="element-265">Day 1:</strong> Applied the first patch Thursday
                morning. Small, thin, invisible under my shirt. Went to work.
                Had my usual wine that night. Nothing felt dramatically
                different.
              </p>

              <p className="mb-6" data-id="element-266">
                <strong data-id="element-267">Day 3:</strong> I noticed something subtle. The usual
                afternoon anxiety—that building tension—was quieter.
              </p>

              <p className="mb-6" data-id="element-268">
                <strong data-id="element-269">Day 5:</strong> That night, I poured wine at 7:30
                instead of 6:00. Drank one glass. Didn't want a second.
              </p>

              <p className="mb-6" data-id="element-270">
                <strong data-id="element-271">Day 7:</strong> Mike had said this was the day. I texted
                him: "Today's the day. I'm scared."
              </p>

              <p className="mb-6" data-id="element-272">
                He responded: "Your brain has been rebuilding GABA for a week.
                Your nervous system is ready."
              </p>

              <p className="mb-8" data-id="element-273">
                That evening, I didn't drink. My husband stayed up with me. I
                slept fitfully. But I slept.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-274">
                The Quit That Finally Worked
              </h2>

              {/* IMAGE 6: Calendar progression */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-275">
                <img src="https://cdn.magicpatterns.com/uploads/6o3BWzWieAeaWrz7JfhkWM/ChatGPT_Image_24_Φεβ_2026,_10_44_35_μ.μ..png" alt="Calendar showing danger zone tracking with handwritten notes marking Hour 12, 24, 36, and 72 with checkmarks" className="w-full h-auto" data-id="element-276" />
              </div>

              <p className="mb-6" data-id="element-277">
                <strong data-id="element-278">Hour 12 (Saturday morning):</strong> Woke up anxious.
                Heart rate elevated but not racing. My husband checked on me
                every hour. "Nervous. But okay."
              </p>

              <p className="mb-6" data-id="element-279">
                <strong data-id="element-280">Hour 24:</strong> Uncomfortable. Restless. But no
                shaking. Heart rate: 88 BPM.
              </p>

              <p className="mb-6" data-id="element-281">
                <strong data-id="element-282">Hour 36:</strong> This was it. The moment I'd had the
                seizure last time.
              </p>

              <p className="mb-6" data-id="element-283">
                I sat on the couch. My husband sat next to me. Holding my hand.
                Ready to call 911 if anything started.
              </p>

              <p className="mb-6" data-id="element-284">Nothing started.</p>

              <p className="mb-6" data-id="element-285">
                My body felt tense. My heart was beating faster than normal (95
                BPM). But I wasn't convulsing. I wasn't shaking uncontrollably.
              </p>

              <p className="mb-6" data-id="element-286">We sat there for two hours. Just waiting.</p>

              <p className="mb-6" data-id="element-287">Hour 38 came and went. No seizure.</p>

              <p className="mb-6" data-id="element-288">
                <strong data-id="element-289">Hour 72:</strong> The danger zone was over. I'd made it
                through without a seizure. Without an ER visit. Without putting
                my daughter through that horror again.
              </p>

              <p className="mb-8" data-id="element-290">
                I started crying. Not from panic. From relief.
              </p>

              {/* IMAGE 7: Relief/embrace scene */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-291">
                <img src="https://cdn.magicpatterns.com/uploads/mtsNSMuTHWzu9MAhbnLCdt/ChatGPT_Image_24_Φεβ_2026,_10_44_34_μ.μ..png" alt="Woman embracing husband with tears of relief in home setting" className="w-full h-auto" data-id="element-292" />
              </div>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-293">
                This Isn't Just My Story
              </h2>

              <TestimonialBox testimonials={testimonials} data-id="element-294" />

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-295">
                What Makes This Different
              </h2>

              {/* IMAGE 8: Product shot */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-296">
                <img src="https://cdn.magicpatterns.com/uploads/hqHcYNk7UzJgEW3o3A24Xn/ChatGPT_Image_24_Φεβ_2026,_10_44_27_μ.μ..png" alt="Glisera Anti-Alcohol Patch product box and patches displayed on outdoor table" className="w-full h-auto" data-id="element-297" />
              </div>

              <p className="mb-6" data-id="element-298">
                I tried therapy. AA. Medication. Supplements. They all failed.
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-299">
                Here's why the Glisera patch worked:
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-300">
                It Addresses the Root Cause
              </h3>

              <p className="mb-8" data-id="element-301">
                Everything else treated symptoms or relied on willpower. The
                patch addresses what's actually broken: your GABA-depleted
                nervous system.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-302">
                It Prepares You BEFORE the Crisis
              </h3>

              <p className="mb-8" data-id="element-303">
                Medical detox treats you DURING the crisis. The preparation
                method prevents the crisis from happening in the first place.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-304">
                It's Transdermal
              </h3>

              <p className="mb-8" data-id="element-305">
                I'd tried oral supplements. They didn't work because alcohol
                damages your gut. Transdermal delivery goes directly through
                your skin into your bloodstream.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-306">
                Clinically-Studied Ingredients:
              </h3>

              <div className="bg-gray-50 p-6 rounded-lg mb-8" data-id="element-307">
                <ul className="space-y-4" data-id="element-308">
                  <li data-id="element-309">
                    <strong data-id="element-310">Kudzu Extract (500mg)</strong> - Reduces alcohol
                    cravings
                  </li>
                  <li data-id="element-311">
                    <strong data-id="element-312">Magnesium Threonate (200mg)</strong> - Calms neural
                    hyperexcitability
                  </li>
                  <li data-id="element-313">
                    <strong data-id="element-314">B-Vitamin Complex</strong> - Replenishes depleted
                    nutrients
                  </li>
                  <li data-id="element-315">
                    <strong data-id="element-316">GABA Precursors</strong> - Rebuilds natural calming
                    ability
                  </li>
                </ul>
              </div>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-317">
                Common Questions
              </h2>

              <div className="bg-gray-50 p-8 rounded-lg my-12" data-id="element-318">
                <div className="space-y-6" data-id="element-319">
                  <div data-id="element-320">
                    <h4 className="font-bold text-gray-900 mb-2" data-id="element-321">
                      "What if I have another seizure?"
                    </h4>
                    <p className="text-gray-700" data-id="element-322">
                      The preparation method minimizes seizure risk by
                      rebuilding GABA before you quit. Have someone with you for
                      the first 72 hours.
                    </p>
                  </div>

                  <div data-id="element-323">
                    <h4 className="font-bold text-gray-900 mb-2" data-id="element-324">
                      "Will people know I'm wearing it?"
                    </h4>
                    <p className="text-gray-700" data-id="element-325">
                      No. The patch is small, thin, and flesh-toned. Completely
                      hidden under normal clothing.
                    </p>
                  </div>

                  <div data-id="element-326">
                    <h4 className="font-bold text-gray-900 mb-2" data-id="element-327">
                      "How long does it take to work?"
                    </h4>
                    <p className="text-gray-700" data-id="element-328">
                      Wear it for 7 days while still drinking, then quit on day
                      8. Most people report significantly reduced symptoms
                      during the 72-hour danger zone.
                    </p>
                  </div>

                  <div data-id="element-329">
                    <h4 className="font-bold text-gray-900 mb-2" data-id="element-330">
                      "I can't afford medical detox..."
                    </h4>
                    <p className="text-gray-700" data-id="element-331">
                      Neither could I. Medical detox costs $5,000-$30,000. The
                      Glisera patch costs $89 for a month supply.
                    </p>
                  </div>
                </div>
              </div>

              <CTASection variant="primary" data-id="element-332" />

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-16 mb-6 font-sans" data-id="element-333">
                Don't Wait Like I Did
              </h2>

              {/* IMAGE 9: Hospital hallway */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-334">
                <img src="https://cdn.magicpatterns.com/uploads/havKkucZvavUTiteCK4rgK/ChatGPT_Image_24_Φεβ_2026,_10_44_30_μ.μ..png" alt="Woman being wheeled on gurney through hospital hallway by paramedics" className="w-full h-auto" data-id="element-335" />
              </div>

              <p className="mb-6" data-id="element-336">
                I almost died on my kitchen floor. My daughter watched me
                convulse.
              </p>

              <p className="mb-6" data-id="element-337">All because I tried to quit cold turkey.</p>

              <p className="mb-6" data-id="element-338">
                I didn't know about GABA depletion. I didn't know withdrawal
                could cause seizures. I didn't know there was a way to prepare
                my nervous system first.
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-339">Now you do.</p>

              <p className="mb-6" data-id="element-340">
                Every day you wait is another day at risk. If you try to quit
                cold turkey, you're gambling with your life.
              </p>

              <p className="mb-6" data-id="element-341">
                Seizures can be fatal. Cardiac events can be fatal. The danger
                is real.
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-342">
                But it's preventable.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-343">
                What One Month Could Mean For You
              </h2>

              <ul className="space-y-2 mb-8 text-gray-700 font-serif" data-id="element-344">
                <li data-id="element-345">
                  ✓ Quitting safely at home without the $15,000 medical detox
                  bill
                </li>
                <li data-id="element-346">✓ Making it past hour 36 without shaking or seizing</li>
                <li data-id="element-347">✓ Sleeping through the night without 3 AM panic</li>
                <li data-id="element-348">✓ Your children not watching you convulse</li>
                <li data-id="element-349">✓ Your nervous system prepared instead of in crisis</li>
                <li data-id="element-350">✓ Freedom from the fear of trying to quit</li>
              </ul>

              <a href="https://thegliserastore.com/products/glissera-anti-alcohol-patch" className="w-full bg-[#1E4D3D] hover:bg-[#163a2e] text-white font-bold py-4 px-6 rounded shadow-lg transition-transform hover:scale-[1.01] text-center text-sm md:text-base uppercase tracking-wide mb-4 block" data-id="element-351">
                CHECK AVAILABILITY NOW
              </a>

              <p className="text-center text-gray-600 text-sm mb-12" data-id="element-352">
                60-Day Money-Back Guarantee — If you don't make it through the
                72-hour danger zone without crisis symptoms, return it for a
                full refund. No questions asked.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-16 mb-6 font-sans" data-id="element-353">
                One Last Thing
              </h2>

              {/* IMAGE 10: Mother-daughter outdoor scene */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-354">
                <img src="https://cdn.magicpatterns.com/uploads/1ZX3M7SvpL2y6iJg2b7qTZ/ChatGPT_Image_24_Φεβ_2026,_10_44_28_μ.μ..png" alt="Mother and teenage daughter walking together in park during golden hour, smiling and reconnected" className="w-full h-auto" data-id="element-355" />
              </div>

              <p className="mb-6" data-id="element-356">
                That morning when I woke up with paramedics over me, my
                daughter's face is burned into my memory. Terror. Confusion.
                Fear.
              </p>

              <p className="mb-6" data-id="element-357">
                This morning, she came into the kitchen and asked if I wanted to
                go for a walk after school.
              </p>

              <p className="mb-6" data-id="element-358">
                We walked for an hour. We talked about her friends, her dreams.
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-359">
                She told me she feels safe again.
              </p>

              <p className="mb-8" data-id="element-360">
                To have my daughter feel safe. To not live in fear of my own
                brain. To know I can quit without risking my life.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-361">
                The Choice Is Yours
              </h2>

              <p className="mb-6" data-id="element-362">
                You can stay where you are. Keep drinking because you're too
                terrified to quit. Live with the constant fear that one day
                you'll try the wrong way and end up in the ER.
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-363">
                Or you can prepare your nervous system first. Give your brain
                the GABA it needs. Calm the hyperexcitability before it becomes
                a seizure. Quit safely, at home, without the medical crisis.
              </p>

              <p className="mb-6" data-id="element-364">
                This isn't about being "strong enough." You're already strong
                enough.
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-365">
                This is about being prepared enough.
              </p>

              <p className="mb-8" data-id="element-366">
                Your nervous system needs biochemical support, not willpower.
              </p>

              <CTASection variant="final" data-id="element-367" />
            </div>
          </article>

          {/* Sidebar Column */}
          <aside className="hidden lg:block w-[35%]" data-id="element-368">
            <ProductSidebar data-id="element-369" />
          </aside>
        </div>
      </main>

      <StickyBottomBar data-id="element-370" />
    </div>;
}